goog.provide("shadow.js.shim.module$ol$style");
goog.provide("module$shadow_js_shim_module$ol$style");
shadow.js.shim.module$ol$style = shadow.js.nativeProvides["ol/style"] = shadow$bridge("ol/style");
module$shadow_js_shim_module$ol$style.default = shadow.js.shim.module$ol$style;
